import React from "react";
import GelServices from "./GelServices";
import InnerNavi from "../../InnerServicePage/InnerNavi/InnerNavi";
import Members from "../../HomePage/Members/Members";
import OurSalon from "../../HomePage/OurSalon/OurSalon";
import InstaFeed from "../../HomePage/InstaFeed/InstaFeed";
import Partners from "../../HomePage/Partners/Partners";
import HelpNearYou from "../../Help/HelpNearYou";
import TextLocReviews from "../../TextLocReviews/TextLocReviews";
import ServiceWhy from "../../MainServicePages/ServiceWhy/ServiceWhy";

const GelNailArtHead = () => {
  return (
    <div className="nailExtensionHead">
      <InnerNavi
        link="/nails-salon"
        service="Nails Salon"
        currService="Gel Nail Art"
      />

      <div className="nailExtensionHeading">
        <h1>Gel Nail Art in Bangalore at SCENT </h1>
        <p>
          If you're looking for a way to elevate your nail game, "{" "}
          <a href="https://scentlifestyle.com/gel-nail-art">
            Gel Nail Art in Bangalore
          </a>{" "}
          " offers an excellent option. SCENT provides{" "}
          <a href="https://scentlifestyle.com/gel-nail-art">
            top-notch gel nail art services
          </a>
          , ensuring your nails look stunning and stay durable for weeks. Here's
          everything you need to know about this trendy nail service:
        </p>
      </div>

      <GelServices />
      <Members />
      <OurSalon />
      <Partners />
      <InstaFeed />
      <HelpNearYou />
      <TextLocReviews />
      <ServiceWhy />
      <div className="nailExtensionHeading">
        <h2>What is Gel Nail Art?</h2>
        <p>
          Gel nail art is a type of nail enhancement that uses{" "}
          <a href="https://scentlifestyle.com/nails-salon"> gel-based polish</a>{" "}
          and a UV or LED light to cure the polish and lock it onto your nails.
          This process ensures a long-lasting, high-shine finish that is more
          durable than{" "}
          <a href="https://scentlifestyle.com/nails-salon">
            traditional nail polish
          </a>
          .
        </p>
      </div>
      <div className="nailExtensionHeading">
        <h3>Why Choose Gel Nail Art?</h3>
        <ul>
          <li>
            <span>Durability:</span> Gel nails are less prone to chipping and
            can last up to three weeks with proper care.
          </li>
          <li>
            <span>High Shine:</span> The curing process leaves a glossy finish
            that remains intact throughout the wear period.
          </li>
          <li>
            <span>Quick Drying:</span> Once cured under the light, your nails
            are completely dry and ready to go.
          </li>
          <li>
            <span>Versatility:</span> Gel nail art allows for a variety of
            designs, from simple solid colors to intricate patterns and
            embellishments.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default GelNailArtHead;
